import React, { useContext, useRef, useState, useEffect, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import * as bootstrap from "bootstrap";
import { Tooltip } from "bootstrap";
import SvgIcon from "../icon/iconSvg";
import NavMenu from "./NavMenu";
import Footer from "./Footer";
import { dateFormat, isArray, validateImageSize, isEnabled, isFeautureEnabled, hasKeys, getSearchParams } from "../../services/utils/validation";
import { useProfile } from "../../services/utils/profileContext";
import ImageCropContext from "../../services/utils/imageCrop";
import NotifyContext from "../../services/utils/notify";
import { useAccountSettings } from "../../services/Context/AccSettingContext";
import { appConst, resourceConst } from "../../services/constant/constant";
import { useManageResource } from "../../services/Context/ManageResourceContext";
import { useLanguageRes } from "../../services/Context/LanguageContext";
import { MessageCountBadge } from "../../components/modules/message/MessageNotification";
import ShowSvgIcon from "../../services/utils/ShowSvgIcon";
import VerifyIdentity from "../../components/modules/patient/proofupload/ExtProofVerification";
import { useTenantSignalREvent } from "../../services/hooks/useTenantSignalR";

const Layout = (props) => {
  const loactionPaths = ["/dashboard", "/visit/detail", "/profile", "/alldocuments", "/vitals", "/insurance", "/forms", "/message", "/familymember", "/consultation", "/orderlab"];

  const [profileResAction, setProfileResAction] = useState([]);
  const [getUserProfile, setUserProfile] = useState({
    photoPath: null,
    dob: null,
    genderId: "",
  });
  const [file, setFile] = useState(null);
  const [photoURL, setPhotoURL] = useState("");
  const [homepageRes, setHomepageRes] = useState(null);
  const [cropedURL, setCropedURL] = useState("");
  const [openCrop, setOpenCrop] = useState(false);
  const [resources, setResources] = useState(null);
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();
  const { getLanguageContent } = useLanguageRes();
  const { notifyToast } = useContext(NotifyContext);
  const { profileContext, imageUrl, deleteProfilePhoto, patientInfo, getPatient } = useProfile();
  const { showCropImage } = useContext(ImageCropContext);
  const { account, accountDate, updateHomeUrl, accountSettings, accountModules, extAppRedirectUrl, fontSize, accountPartners } = useAccountSettings();

  const { getCurrentResource, resourceList, getCurrentResourceAction, actionExists } = useManageResource();
  const aspect = 1;

  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const profileupload = useRef(null);
  const tooltipInstanceRef = useRef(null);

  const handleOutsideClick = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target) && e.target !== buttonRef.current) setIsNavCollapsed(true);
  };

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  getUserProfile.photoPath = cropedURL == "" ? getUserProfile.photoPath : cropedURL;

  function CheckPath(pathnameToCheck) {
    if (location.pathname === pathnameToCheck) {
      return "active";
    }
    return "";
  }

  const handleChange = (e) => {
    e.preventDefault();
    e.stopPropagation();
    var isValidImg = validateImageSize(e.target?.files[0], 5);
    if (isValidImg == "succeed") {
      const file = e.target?.files[0];
      var photoURL = URL.createObjectURL(file);
      showCropImage({
        ...{
          photoURL,
          setOpenCrop,
          setPhotoURL,
          setFile,
          setCropedURL,
          aspect,
        },
      });
      if (file) {
        setFile(file);
        setCropedURL(null);
        setPhotoURL(URL.createObjectURL(file));
        setOpenCrop(true);
      }
    } else {
      notifyToast(isValidImg);
    }
  };

  const handleDelete = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const dropdownEl = e.target.closest(".dropdown");
    const dropdown = bootstrap.Dropdown.getInstance(dropdownEl.querySelector('[data-bs-toggle="dropdown"]'));
    if (dropdown) {
      dropdown.hide();
    }

    const confirmed = window.confirm("Are you sure you want to delete?");
    if (confirmed) {
      deleteProfilePhoto();
    }
  };

  const handleUploadClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (profileupload.current) {
      profileupload.current.value = "";

      setTimeout(() => {
        profileupload.current.click();
      }, 100);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (isArray(resourceList?.resources)) {
      const _homePageResource = getCurrentResource(appConst.resource.publicResource);
      // HomePageRes
      if (Array.isArray(_homePageResource) && _homePageResource?.length > 0) {
        const _temp = _homePageResource?.find((list) => list.code == "CW6");
        if (_temp) {
          setHomepageRes(_temp);
          updateHomeUrl(_temp?.url);
        }
      }

      const fetchData = async () => {
        try {
          let _resourceList = getCurrentResource(appConst.resource.menu);

          if (isArray(_resourceList)) {
            _resourceList.push({
              title: getLanguageContent("frmlgt") || "Logout",
              url: "/security/logout",
              icon: "#svg_exit",
            });
          }

          setResources(_resourceList);
          const actionList = () => {
            const _actions = getCurrentResourceAction("PIN", "EQ7");
            setProfileResAction(_actions);
          };
          actionList();
        } catch (error) {
          console.log(error);
        }
      };

      fetchData();
    }
  }, [resourceList?.resources]);

  // Direct-URL access to a nav-driven page whose resource is no longer active for this account
  // (e.g. disabled in Settings) must be blocked the same way it's hidden from the sidebar —
  // otherwise a stale/bookmarked link (e.g. /insurance, or /insurance?rcode=SQ4) still loads the
  // page. Sidebar links carry their resource code as `?rcode=` (see the Link `to` below), and
  // internal navigate() calls that jump to a nav-driven page pass the same param, so prefer
  // matching on that; when it's absent (a bare URL was typed/bookmarked) fall back to matching
  // the path itself against the account's active resources. Scoped to loactionPaths — the same
  // set of nav-driven pages this Layout already special-cases below — so workflow/intake routes
  // (which aren't backed by a Resource row at all) are never affected.
  useEffect(() => {
    if (!isArray(resourceList?.resources) || !loactionPaths?.includes(location.pathname)) return;

    const _rcode = getSearchParams("rcode");
    const _isActiveResource = _rcode ? resourceList.resources.some((list) => list?.code === _rcode) : resourceList.resources.some((list) => list?.url === location.pathname);

    if (!_isActiveResource) {
      navigate("/page-access-denied", { replace: true });
    }
  }, [location.pathname, location.search, resourceList?.resources, navigate]);

  const setInfoEl = useCallback((node) => {
    // node === null when unmounting
    if (!node) {
      tooltipInstanceRef.current?.dispose?.();
      tooltipInstanceRef.current = null;
      return;
    }

    // dispose if React replaced the node
    tooltipInstanceRef.current?.dispose?.();

    tooltipInstanceRef.current = Tooltip.getOrCreateInstance(node, {
      trigger: "hover focus click",
      container: "body",
    });
  }, []);

  useTenantSignalREvent(
    "ReceiveEvent",
    (message) => {
      if (message.eventType === "profile_updated") {
        getPatient();
      }
    },
    "patient"
  ); // ← listening on patient hub

  return (
    <>
      <SvgIcon />
      {/* Nav, sidebar and footer wait for the resource list; the routed page does not.
          Header and footer also wait for the account (logo/name, HRC/FTC content) — otherwise they
          paint as empty theme-coloured bars on reload until the account resolves. */}
      {!props.isViewer && isArray(resources) && account && <NavMenu cropedURL={cropedURL} setting={false} isLogin={props.islogin} profile={profileContext} home={homepageRes} />}
      <div className={`bg-light ${(loactionPaths?.includes(location.pathname) && !extAppRedirectUrl) || location.pathname === "/session" ? "" : "container-xxl p-3 p-md-4"} main-container`}>
        {!extAppRedirectUrl && loactionPaths?.includes(location.pathname) && isArray(resources) ? (
          <div className="d-flex flex-md-row flex-column">
            <div id="lnavbardiv" className={`l-navbar flex-shrink-0 p-0 align-self-stretch`}>
              <div className="d-flex flex-column justify-content-center align-items-center text-center">
                <div className="my-3">
                  <div htmlFor="filePhoto" className=" position-relative profile-pic-upload py-4">
                    <input ref={profileupload} id="filePhoto" type="file" accept="image/png, image/jpeg, image/jpg" className="form-control d-none" onChange={handleChange} key="profile-upload-input" />
                    <img
                      loading="lazy"
                      className="rounded-2 img-fluid"
                      width="100%"
                      src={imageUrl ? imageUrl : profileContext?.resProfile?.photoPath ? "doc/getimage/true?url=" + encodeURIComponent(profileContext?.resProfile?.photoPath) : require("../../asset/images/blankuser.png")}
                      alt="User Profile"
                    />
                    <div className="dropdown">
                      <span role="button" data-bs-toggle="dropdown" aria-expanded="false" className="position-absolute  bottom-0 start-100 translate-middle badge rounded-circle bg-dark p-1 me-2 image-croper-camera-icon">
                        <svg width="16" height="16" role="img" fill="currentColor">
                          <use xlinkHref="#edit_icon_pencil"></use>
                        </svg>
                      </span>
                      <ul className="dropdown-menu">
                        <li>
                          <a className="dropdown-item" onClick={handleUploadClick}>
                            {getLanguageContent("dasupl")}
                          </a>
                        </li>
                        {profileContext?.resProfile?.photoPath && actionExists(profileResAction, resourceConst?.actions?.edit) && (
                          <li>
                            <a className="dropdown-item" onClick={handleDelete} data-bs-dismiss="dropdown">
                              {getLanguageContent("dasrem")}
                            </a>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="flex-grow-1 position-relative">
                  {profileContext?.resProfile?.firstName && profileContext?.resProfile?.lastName && (
                    <h5 className="m-0">
                      {`${profileContext?.resProfile?.firstName} ${profileContext?.resProfile?.lastName}`}
                      {hasKeys(accountPartners) && accountPartners["VRF"] && isFeautureEnabled(accountModules, "IFM") && (patientInfo?.verificationStatusId == "2" || patientInfo?.verificationStatusId == "1") && (
                        <>
                          {patientInfo?.verificationStatusId == "1" ? (
                            <ShowSvgIcon size={fontSize} className={"ms-1"} width={16} height={16} id={"info-verified"} />
                          ) : (
                            <>
                              {getLanguageContent("iyghbu") && (
                                <>
                                  <span className="ms-1" ref={setInfoEl} data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title={getLanguageContent("iyghbu")}>
                                    <ShowSvgIcon size={fontSize} width={16} height={16} id={"info-unverified"} />
                                  </span>
                                </>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </h5>
                  )}

                  {profileContext?.resProfile?.dob && (
                    <>
                      <h6 className="text-muted m-0">
                        <ShowSvgIcon size={fontSize} className={"me-1"} width={20} height={20} id={"svg_cake"} />
                        {dateFormat(profileContext?.resProfile?.dob, accountDate?.value)}
                      </h6>
                    </>
                  )}
                </div>
                <div className="d-block d-md-none">
                  <button
                    class="btn btn-transparent p-0 m-0 btn-outline-none border-0"
                    ref={buttonRef}
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded={!isNavCollapsed ? true : false}
                    aria-label="Toggle navigation"
                    onClick={handleNavCollapse}
                  >
                    {isNavCollapsed ? (
                      <svg width="12" height="7">
                        <use xlinkHref="#svg_arrowdown"></use>{" "}
                      </svg>
                    ) : (
                      <svg width="7" height="12">
                        <use xlinkHref="#svg_arrowright"></use>{" "}
                      </svg>
                    )}
                  </button>
                </div>
                {hasKeys(accountPartners) && accountPartners["VRF"] && isFeautureEnabled(accountModules, "IFM") && patientInfo?.verificationStatusId == "2" && (
                  <div>
                    <VerifyIdentity isAutoStart={true} isShowLink={true} />
                  </div>
                )}
              </div>
              <hr />
              <div use={menuRef} className={`px-3 mb-3 ${isNavCollapsed ? "collapse" : ""} nav_list navbar-collapse`} id="navbarSupportedContent">
                {isArray(resources) && (
                  <>
                    {resources
                      ?.filter((list) => {
                        // Exclude Family Member menu for patient linked with parent
                        if (patientInfo?.parentId && list?.code === "SK6") {
                          return false;
                        }

                        // Exclude logout when External User identity is enabled
                        if (list?.url === "/security/logout" && !isEnabled(accountSettings, "DUL", 0)) {
                          return false;
                        }

                        return true;
                      })
                      ?.map((menu, i) => (
                        <>
                          {menu?.url?.includes("https://") ? (
                            <a className={`nav_link`} href={menu?.url ? menu?.url : "/pagenotfound"}>
                              <span className="nav_icon_wrap">
                                <svg className="nav_icon mt-1" width="24" height="24" role="img">
                                  <use xlinkHref={menu?.icon} />
                                </svg>
                                {menu?.url === "/message" && isFeautureEnabled(accountModules, "MSG") && <MessageCountBadge />}
                              </span>
                              <span
                                className="nav_name"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                <span
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "5rem",
                                  }}
                                >
                                  {menu?.title}
                                </span>
                              </span>
                            </a>
                          ) : (
                            <Link
                              onClick={() => setIsNavCollapsed(true)}
                              className={`nav_link  ${CheckPath(menu?.url)}  ${location.pathname === "/visit/detail" && i === 0 ? "active " : ""} `}
                              to={menu?.url ? `${menu?.url}${menu?.code ? `?rcode=${menu?.code}` : ""}` : "/pagenotfound"}
                              key={i}
                            >
                              <span className="nav_icon_wrap">
                                <svg className="nav_icon" width="24" height="24" role="img">
                                  <use xlinkHref={menu?.icon} />
                                </svg>
                                {menu?.url === "/message" && isFeautureEnabled(accountModules, "MSG") && <MessageCountBadge />}
                              </span>
                              <span
                                className="nav_name"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                <span
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "5rem",
                                  }}
                                >
                                  {menu?.title}
                                </span>
                              </span>
                            </Link>
                          )}
                        </>
                      ))}
                  </>
                )}
              </div>
            </div>
            <div className="flex-grow-1 m-3 content-container">{props.children}</div>
          </div>
        ) : (
          props.children
        )}
      </div>
      {!props.isViewer && isArray(resources) && account && <Footer />}
    </>
  );
};

export default Layout;
